// extracted by mini-css-extract-plugin
var _1 = "wJZq290M";
export { _1 as "header" }
